import { FiMessageSquare } from 'react-icons/fi';
import { useChat } from '../../contexts/ChatContext';
import { useMemberAuth } from '../../contexts/MemberAuthContext';
import { cn } from '../../utils/helpers';

/**
 * Conversations trigger for the main navigation bar.
 *
 * Renders nothing for signed-out visitors — chat has no guest mode, so an
 * unauthenticated socket never connects and the icon would only lead to a login
 * wall — and nothing when Conversations is turned off in the admin settings, or
 * closed to this member for being unverified or suspended. `chatEnabled` covers
 * all of those: it is the chat service's own answer, not a mirrored flag.
 *
 * `className` carries the header's current text colour, which changes with
 * scroll state and transparent-header pages.
 */
export default function ChatNavButton({ className, size = 20 }) {
  const { isAuthenticated } = useMemberAuth();
  const { openPanel, totalUnread, chatEnabled } = useChat();

  if (!isAuthenticated || !chatEnabled) return null;

  const label = totalUnread > 0
    ? `Conversations, ${totalUnread} unread`
    : 'Conversations';

  return (
    <button
      onClick={() => openPanel()}
      className={cn(
        'relative pl-2 rounded-lg',
        className
      )}
      aria-label={label}
      title="Conversations"
    >
      <FiMessageSquare style={{ width: size, height: size }} />

      {totalUnread > 0 && (
        <span
          aria-hidden="true"
          className="absolute top-0.5 right-0 min-w-[17px] h-[17px] px-1 rounded-full
                     bg-accent text-primary text-[10px] font-semibold leading-none
                     flex items-center justify-center ring-2 ring-white"
          style={{ width: size, height: size }}
        >
          {totalUnread > 99 ? '99+' : totalUnread}
        </span>
      )}
    </button>
  );
}
